function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const SvgTopBottom = styled.svg.withConfig({
  componentId: "sc-15iuvok-0"
})(["display:block;width:100%;", ";"], props => {
  switch (props.origin) {
    case "bottom":
      return "transform: rotate(180deg);";

    default:
      return "";
  }
});
const SvgStartEnd = styled.svg.withConfig({
  componentId: "sc-15iuvok-1"
})(["display:block;height:100%;", ";", ""], props => {
  switch (props.origin) {
    case "end":
      return "transform: rotate(180deg) scaleY(-1)";

    default:
      return "";
  }
}, dir("rtl")`
    ${props => {
  switch (props.origin) {
    case "start":
      return "transform: rotate(180deg) scaleY(-1)";

    case "end":
      return "transform: none";

    default:
      return "";
  }
}};
  `);

const Narrow = _ref => {
  let {
    origin = "top",
    color = "currentColor",
    ...props
  } = _ref;
  const colorCode = color.replace(/#/, "");
  return origin === "top" || origin === "bottom" ? /*#__PURE__*/React.createElement(SvgTopBottom, _extends({
    origin: origin,
    viewBox: "0 0 297 77",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-a-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".25",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-b-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".15",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    y2: "50%",
    id: `eden-light-rays-regular-c-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v19.191l297 19.191V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-b-${colorCode})`,
    d: "M0 0v76.765L267.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v38.382L297 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-c-${colorCode})`,
    d: "M0 19.191h297V0H0z"
  })) : /*#__PURE__*/React.createElement(SvgStartEnd, _extends({
    origin: origin,
    viewBox: "0 0 77 297",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-a-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".25",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: `eden-light-rays-regular-b-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".15",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    y2: "50%",
    id: `eden-light-rays-regular-c-${colorCode}`
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: color,
    stopOpacity: ".35",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v19.191l297 19.191V0z",
    transform: "matrix(0 -1 1 0 0 297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-b-${colorCode})`,
    d: "M0 0v76.765L267.3 0z",
    transform: "matrix(0 -1 1 0 0 297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-a-${colorCode})`,
    d: "M0 0v38.382L297 0z",
    transform: "matrix(0 -1 1 0 0 297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: `url(#eden-light-rays-regular-c-${colorCode})`,
    d: "M0 19.191h297V0H0z",
    transform: "matrix(0 -1 1 0 0 297)"
  })));
};

Narrow.propTypes = {
  /** The base color of the light rays */
  color: PropTypes.string,

  /** Which direction the light rays originate from */
  origin: PropTypes.oneOf(["top", "bottom", "start", "end"])
};
export default Narrow;